import { Entry } from '../Entry'

export function Entry20240821() {
  return (
    <Entry title="21/08/2024 - v3.8.0">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/15958/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
